import { Component } from "@angular/core";
import { ForgotPasswordComponent } from "../forgot-password/forgot-password.component";

@Component({
  selector: "app-forgot-password-page",
  imports: [ForgotPasswordComponent],
  templateUrl: "./forgot-password-page.component.html",
  styles: ``,
})
export class ForgotPasswordPageComponent {}
